// CAPO/Nova/Cinder failure messages are gophercloud strings that bury the one
// useful sentence inside a trailing JSON body, e.g.
//   ...but got 403 instead: {"forbidden":{"code":403,"message":"Quota exceeded
//   for instances: Requested 1, but already used 11 of 11 instances"}}
// extractErrorSummary pulls that inner `.message` out so the modal can show it
// as a crisp headline above the raw text. Returns null when there is nothing
// worth extracting (no JSON, malformed JSON, or the summary equals the raw
// message), letting the caller fall back to showing only the raw block.

const findDeepestMessage = (
  value: unknown,
  depth: number,
  best: { message: string; depth: number } | null,
): { message: string; depth: number } | null => {
  if (Array.isArray(value)) {
    return value.reduce((acc, item) => findDeepestMessage(item, depth + 1, acc), best)
  }
  if (value && typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>).reduce((acc, [key, val]) => {
      let next = acc
      if (key === 'message' && typeof val === 'string' && val.trim()) {
        // Deeper wins; ties keep the first encountered (acc).
        if (!next || depth > next.depth) next = { message: val.trim(), depth }
      }
      return findDeepestMessage(val, depth + 1, next)
    }, best)
  }
  return best
}

export function extractErrorSummary(message: string): string | null {
  if (!message) return null

  const start = message.indexOf('{')
  if (start === -1) return null

  let parsed: unknown
  try {
    parsed = JSON.parse(message.slice(start))
  } catch {
    return null
  }

  const found = findDeepestMessage(parsed, 0, null)
  if (!found) return null
  if (found.message === message.trim()) return null
  return found.message
}
